export default {"src":"/_next/static/media/Loggly.81cf6689.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};